import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../../App';
import featureslt from '../../Assets/OurFeatures/featureslt.png';
import featureslb from '../../Assets/OurFeatures/featureslb.png';
import feauresrt from '../../Assets/OurFeatures/featuresrt.png';
import featuresrb from '../../Assets/OurFeatures/featuresrb.png';
import middleImage from '../../Assets/OurFeatures/featuresmiddle.png';
import featureTopLeft from '../../Assets/OurFeatures/featuresrightt.png';

const FeatureCard = ({ title, description, icon, isVisible }) => {
  return (
    <div 
      className={`bg-[#030B15] border border-[#1A4D90] flex flex-col items-center justify-center p-6 
      transition-all duration-500 ease-in-out cursor-default
      hover:bg-[#051121] hover:border-[#3b82f6] hover:-translate-y-2 hover:shadow-[0_10px_30px_rgba(26,77,144,0.3)]
      ${isVisible ? 'animate-slow-fall' : 'opacity-0'}`}
      style={{ width: '309.38px', height: '318px' }}
    >
      <img 
        src={icon} 
        alt="icon" 
        style={{ width: '70.49px', height: '70.49px', marginBottom: '20px' }} 
      />
      <h4 className="text-white font-alexandria font-semibold text-[25px] text-center mb-4 leading-[100%]">
        {title}
      </h4>
      <p className="text-[#7D7D7D] font-alexandria font-light text-[20px] leading-[26px] text-center max-w-[285px]">
        {description}
      </p>
    </div>
  );
};

const OurFeatures = () => {
  const { t, language } = useLanguage();
  const isArabic = language === 'ar';
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 }
    );
    if (currentRef) observer.observe(currentRef);
    return () => { if (currentRef) observer.unobserve(currentRef); };
  }, []);

  const styles = `
    @keyframes slowFallDown {
      0% { transform: translateY(-50px); opacity: 0; }
      100% { transform: translateY(0); opacity: 1; }
    }
    .animate-slow-fall {
      animation: slowFallDown 1.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
    }
    .middle-image-hover:hover {
      transform: scale(1.08) !important;
      transition: transform 0.5s ease-in-out;
    }
  `;

  return (
    <div 
      ref={sectionRef}
      className="relative w-full bg-[#030B15] flex flex-col items-center py-20 overflow-hidden"
      style={{ minHeight: '910px' }}
    >
      <style>{styles}</style>
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden z-10">
        <img 
          src={featureTopLeft} 
          alt="" 
          className="absolute block"
          style={{ 
            width: '511.3042997417223px', 
            height: '250.72848950616094px', 
            top: '0px', 
            left: '0px', 
            transform: 'rotate(360deg)', 
            WebkitTransform: 'rotate(360deg)', 
            opacity: '1',
            maxWidth: 'none',
            display: 'block'
          }}
        />
      </div>

      <div className="container mx-auto px-4 relative z-20 flex flex-col items-center">
        
        <div className="text-center space-y-4 max-w-[1232px] mt-10">
          <h3 className="text-[#1A4D90] font-alexandria font-medium text-[25px] leading-[100%]">
            {t('hero.ourFeatures')}
          </h3>
          <h2 className="text-white font-outfit font-medium text-[48px] leading-[100%]">
            {t('hero.featuresSubtitle')}
          </h2>
          <div className="px-4">
            <p className="text-[#CFCFCF] font-alexandria font-light text-[22px] leading-[32px] max-w-[1231px] mx-auto">
              {t('hero.featuresWelcome')}
            </p>
          </div>
        </div>

        <div className={`mt-10 flex flex-col lg:flex-row items-center justify-center gap-10 w-full max-w-[1232px] ${isArabic ? 'lg:flex-row-reverse' : ''}`}>
          
          <div className="flex flex-col gap-10 order-2 lg:order-1">
            <FeatureCard isVisible={isVisible} icon={featureslt} title={t('hero.tradingTools')} description={t('hero.toolsDesc')} />
            <FeatureCard isVisible={isVisible} icon={featureslb} title={t('hero.highLiquidity')} description={t('hero.liquidityDesc')} />
          </div>

          <div className={`transition-all duration-1000 order-1 lg:order-2 ${isVisible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
            <img 
              src={middleImage} 
              alt="Middle" 
              className="middle-image-hover transition-transform duration-500 ease-in-out cursor-pointer"
              style={{ width: '527px', height: '418px', objectFit: 'contain' }} 
            />
          </div>

          <div className="flex flex-col gap-10 order-3">
            <FeatureCard isVisible={isVisible} icon={feauresrt} title={t('hero.educationalResources')} description={t('hero.educationDesc')} />
            <FeatureCard isVisible={isVisible} icon={featuresrb} title={t('hero.liveSupport')} description={t('hero.supportTeam')} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurFeatures;